var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigiProcV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.882812 5.2927C0.882812 2.80217 2.90178 0.783203 5.39231 0.783203H23.4303C25.9208 0.783203 27.9398 2.80218 27.9398 5.2927V23.3307C27.9398 25.8212 25.9208 27.8402 23.4303 27.8402H5.39231C2.90178 27.8402 0.882812 25.8212 0.882812 23.3307V5.2927Z",
    fill: "#5D5FEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3672 11.3899C21.3669 11.114 21.2941 10.8431 21.156 10.6043C21.018 10.3654 20.8195 10.1671 20.5806 10.0291L15.0746 6.88288C14.8355 6.74481 14.5642 6.67212 14.2881 6.67212C14.0119 6.67212 13.7407 6.74481 13.5015 6.88288L7.99555 10.0291C7.75664 10.1671 7.5582 10.3654 7.42015 10.6043C7.28209 10.8431 7.20927 11.114 7.20898 11.3899V17.6824C7.20927 17.9583 7.28209 18.2292 7.42015 18.4681C7.5582 18.7069 7.75664 18.9053 7.99555 19.0432L13.5015 22.1895C13.7407 22.3275 14.0119 22.4002 14.2881 22.4002C14.5642 22.4002 14.8355 22.3275 15.0746 22.1895L20.5806 19.0432C20.8195 18.9053 21.018 18.7069 21.156 18.4681C21.2941 18.2292 21.3669 17.9583 21.3672 17.6824V11.3899Z",
    stroke: "white",
    strokeWidth: 1.21674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43945 10.6038L14.2826 14.5366L21.1257 10.6038",
    stroke: "white",
    strokeWidth: 1.21674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2832 22.4008V14.5352",
    stroke: "white",
    strokeWidth: 1.21674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiProcV2);
export default __webpack_public_path__ + "static/media/digiProcV2.155e74d4ddc04ebb7a87977569328f88.svg";
export { ForwardRef as ReactComponent };